import { FC, ReactNode } from "react"
import Button from "@/components/shared/Button"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"
import { ColorVariant } from "@/types/index"
import "./index.scss"

export enum WearableConnectionStatus {
   CONNECTED = "connected",
   DISCONNECTED = "disconnected",
}

export interface WearableConnectionInfoProps {
   status: WearableConnectionStatus
   wearableId: string
   inmateId: string
   onClose: () => void
}

const contentConfig: Record<
   WearableConnectionStatus,
   { title: ReactNode; icon: IconProps["name"] }
> = {
   [WearableConnectionStatus.CONNECTED]: {
      title: (
         <>
            ReassureBand <br /> Connected
         </>
      ),
      icon: "connected",
   },
   [WearableConnectionStatus.DISCONNECTED]: {
      title: (
         <>
            ReassureBand <br /> Disconnected
         </>
      ),
      icon: "unlinked",
   },
}

const WearableConnectionInfo: FC<WearableConnectionInfoProps> = ({
   status,
   wearableId,
   inmateId,
   onClose,
}) => {
   const { title, icon } = contentConfig[status]

   return (
      <div className="wearable-connection-info">
         <div className="wearable-connection-info__content">
            <div className="wearable-connection-info__header">
               <Icon
                  name={icon}
                  size="52"
                  color={IconColor.HONOLULU_BLUE}
               />
               <div className="wearable-connection-info__title">{title}</div>
            </div>

            <div className="wearable-connection-info__info">
               <div className="wearable-connection-info__column">
                  <div className="wearable-connection-info__label">
                     ReassureBand
                  </div>
                  <div className="wearable-connection-info__value">
                     {wearableId}
                  </div>
               </div>
               <Icon
                  name={icon}
                  size="24"
                  color={IconColor.HONOLULU_BLUE}
               />
               <div className="wearable-connection-info__column">
                  <div className="wearable-connection-info__label">Inmate</div>
                  <div className="wearable-connection-info__value">
                     {inmateId}
                  </div>
               </div>
            </div>
         </div>

         <Button
            color={ColorVariant.HONOLULU_BLUE}
            onClick={onClose}
         >
            Ok
         </Button>
      </div>
   )
}

export default WearableConnectionInfo
